import GeoJsonFetchLayer from './GeoJsonFetchLayer';

// The noise runtime can be notified by both style and viewport changes.
export default class NoiseFetchLayer extends GeoJsonFetchLayer {
    load() {
        const url = this.buildUrl();
        const pending = this.getAbortController();
        const map = this.getMap();
        if (this.isActive() && this.canActivate() && this.requestUrl === url
            && ((pending && !pending.signal.aborted) || (this.loadedUrl === url && map.getSource(this.getSourceId())))) return;
        this.requestUrl = url;
        super.load();
    }

    renderSourceData(data, addLayers) {
        this.renderedFeatures = data && Array.isArray(data.features) ? data.features : [];
        const result = super.renderSourceData(data, addLayers);
        this.loadedUrl = this.requestUrl;
        return result;
    }

    getRenderedFeatures() {
        return this.renderedFeatures || [];
    }

    clear() {
        this.renderedFeatures = [];
        this.loadedUrl = null;
        this.requestUrl = null;
        super.clear();
    }
}
